// view or modify the user

import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Button, TextField } from '@mui/material';
import axios from 'axios';
import { BASEURL, ARROW } from '../../../constants/Common';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import FloatingButton from '../../usersupport/helpdesk/FloatingButton';

interface UserData {
  //   organization_id: number;
  organization_name: string;
  user_role: string;
  username: string;
  email: string;
  employee_id: string;
  user_category: string;
  date_joined: string;
  //   password: string;
  user_title: string;
}

const EditOrModifyUserDetails = () => {
  const [user, setUser] = useState<UserData | null>({
    // organization_id: 0,
    organization_name: '',
    user_role: '',
    username: '',
    email: '',
    employee_id: '',
    user_category: '',
    // password: '',
    user_title: '',
    date_joined: '',
  });
  const [editMode, setEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const storedData = localStorage.getItem('authData');
  let authid: any = null; // Define parsedData variable with 'any' type

  if (storedData) {
    authid = JSON.parse(storedData);
  } else {
    console.log('No data found in localStorage');
  }

  const userId = authid;

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(
          BASEURL + `/user-detailadduser/${userId}`
        );
        setUser(response.data.user);
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUserDetails();
  }, [userId]);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSave = async () => {
    setIsSaving(true)
    try {
      if (!user) return; // Null check to ensure user exists

      const {
        employee_id,
        username,
        organization_name,
        email,
        user_category,
        user_role,
        user_title,
      } = user;
      const payload = {
        employee_id,
        organization_name,
        username,
        email,
        user_category,
        user_role,
        user_title,
      };

      const response = await axios.put(
        BASEURL + `/user-detailadduser/${userId}/`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json', // Set content type to JSON
          },
        }
      );

      toast.success('Updated user successfully');
      setEditMode(false);
    } catch (error) {
      setIsSaving(false)
      console.error('Error updating user details:', error);
      toast.error('Failed to updated user');
    }finally {
      setIsSaving(false); // Ensure the button is re-enabled after the save operation completes
    }
  };

  const handleCancel = () => {
    // Reset user data or fetch again from API to discard changes
    setEditMode(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...(prevUser as UserData), // Cast prevUser to UserData to avoid TypeScript error
      [name]: value,
    }));
  };

  return (
    <Box sx={{ mt: '-70px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flex: 'auto' }}>
          {editMode ? (
            <Typography variant='h6' component='div'>
              <Link to={'/useraccount'}>User Account</Link>
              {ARROW} Edit Account Details
            </Typography>
          ) : (
            <Typography variant='h6' component='div'>
              <Link to={'/useraccount'}>User Account</Link>
              {ARROW} View Account Details
            </Typography>
          )}
        </Box>
        {!editMode && (
          <Box sx={{ marginLeft: 'auto' }}>
            <Button variant='contained' onClick={handleEdit}>
              Edit
            </Button>
          </Box>
        )}
      </Box>
      <Grid container spacing={2}>
        {user && (
          <>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Employee ID:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='employee_id'
                  value={user.employee_id}
                  onChange={handleChange}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.employee_id}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Username:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='username'
                  value={user.username}
                  onChange={handleChange}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.username}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Organization Name:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='organization_name'
                  value={user.organization_name}
                  onChange={handleChange}
                  InputProps={{ readOnly: true }}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.organization_name}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Email:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='email'
                  value={user.email}
                  onChange={handleChange}
                  InputProps={{ readOnly: true }}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.email}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Password:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  fullWidth
                  name='password'
                  type='password' // Set type to 'password' to display dots
                  value={'•••••••'}
                  onChange={handleChange}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  InputProps={{ readOnly: true }}
                />
              ) : (
                <Typography>••••••</Typography> // Display dots or any placeholder text
              )}
            </Grid>

            
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Created Date:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='date_joined'
                  value={user.date_joined}
                  onChange={handleChange}
                  InputProps={{ readOnly: true }}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.date_joined}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Category:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='user_category'
                  value={user.user_category}
                  onChange={handleChange}
                  InputProps={{ readOnly: true }}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.user_category}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>User Role:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='user_role'
                  value={user.user_role}
                  onChange={handleChange}
                  InputProps={{ readOnly: true }}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.user_role}</Typography>
              )}
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'>Title:</Typography>
            </Grid>
            <Grid item xs={8}>
              {editMode ? (
                <TextField
                  variant='outlined'
                  name='user_title'
                  value={user.user_title}
                  onChange={handleChange}
                  sx={{
                    width: editMode ? '350px' : '350px', // Adjust the width based on edit mode
                    maxWidth: editMode ? '350px' : '350px', // Set maximum width based on edit mode
                  }}
                  fullWidth
                />
              ) : (
                <Typography>{user.user_title}</Typography>
              )}
            </Grid>
          </>
        )}
      </Grid>
      {editMode && (
        <Box mt={2} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
          <Button variant='contained' onClick={handleSave} sx={{'&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}>
            Save
          </Button>
          <Button
            variant='contained'
            onClick={handleCancel}
            sx={{ marginLeft: 1 }}
          >
            Cancel
          </Button>
        </Box>
      )}
      <FloatingButton/>
    </Box>
  );
};

export default EditOrModifyUserDetails;
